module.exports = __webpack_public_path__ + "img/sign-in.05750c4c.png";